import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Navigation from '@/components/Navigation';
import MediaDashboard from '@/components/media/dashboard/MediaDashboard';

const MediaLibrary = () => {
  // Get the tab parameter from URL
  const [searchParams] = useSearchParams();
  const tabFromUrl = searchParams.get('tab');
  const navigate = useNavigate();

  // Make sure the tab is properly set in URL if coming from a direct link without tab param
  useEffect(() => {
    if (!tabFromUrl) {
      // Only modify URL if there's no tab param yet
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set('tab', 'library'); // Default to library
      navigate(`${window.location.pathname}?${newSearchParams.toString()}`, { replace: true });
    }
  }, [navigate, searchParams, tabFromUrl]);

  return (
    <Navigation>
      <MediaDashboard initialTab={tabFromUrl || 'library'} />
    </Navigation>
  );
};

export default MediaLibrary;
